module.exports = __webpack_public_path__ + "static/media/ice-coffee.793451d5.png";